export default __webpack_public_path__ + "static/media/Admin@2x.a74ed7d0.png";